import type { ReactNode } from 'react';

import type { CustomDomainsFeature } from '../../../generated/graphql-manager';

import { createContext, useContext } from 'react';

import { useGetFeaturesQuery } from '../../../generated/graphql-manager';
import { useCurrentUser } from '../../hooks/current-user';

type LsproFeaturesContextValue = {
  customDomainsEnabled: boolean | undefined;
};

const LsproFeaturesContext = createContext<LsproFeaturesContextValue>({
  customDomainsEnabled: undefined,
});

export function LsproFeaturesProvider({ children }: { children: ReactNode }) {
  const { lsproId } = useCurrentUser();
  const { data } = useGetFeaturesQuery({ variables: { lsproId }, skip: !lsproId });

  const customDomainsEnabled = data?.lsproSettings?.features?.some(
    (feature): feature is CustomDomainsFeature => feature.__typename === 'CustomDomainsFeature' && feature.enabled
  );

  return <LsproFeaturesContext.Provider value={{ customDomainsEnabled }}>{children}</LsproFeaturesContext.Provider>;
}

export function useLsproFeatures() {
  return useContext(LsproFeaturesContext);
}
